import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/contact/components/ContactInquiryPanel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/sections/Products/FaqEnquiryGrid.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/sections/shared/CommonSpacer.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/sections/Sustainability/SustainabilityInnerPages/SustainabilityEnvironmentBiodiversityFocus.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/sections/Sustainability/SustainabilityInnerPages/SustainabilityEnvironmentCircularityFocus.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/sections/Sustainability/SustainabilityInnerPages/SustainabilityEnvironmentClimateFocus.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/sections/Sustainability/SustainabilityInnerPages/SustainabilityEnvironmentSDGMarquee.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/sections/Sustainability/SustainabilityInnerPages/SustainabilityEnvironmentStandMetricsClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/sections/Sustainability/SustainabilityInnerPages/SustainabilityEnvironmentWaterFocus.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/sections/Sustainability/SustainabilityInnerPages/SustainabilityGovernanceFocusSequence.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/sections/Sustainability/SustainabilityInnerPages/SustainabilityGovernanceSDGStaticSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/sections/Sustainability/SustainabilityInnerPages/SustainabilityGovernanceVisionSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/sections/Sustainability/SustainabilityInnerPages/SustainabilitySocialFocusSequence.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/sections/Sustainability/SustainabilityInnerPages/SustainabilitySocialNeevSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/sections/Sustainability/SustainabilityInnerPages/SustainabilitySocialVisionSection.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/CmsImage.tsx");
